import { Injectable } from '@angular/core';
import { DcTypes, Feature, TypedFeatureProperties } from '../../../../projects/client';
import { Unit } from '../../../shared/common/units';
import { UnitsAdapter } from '../../services/units-adapter/units.adapter';
import { FeatureValueStrategy } from './feature-value-strategy.model';

@Injectable({ providedIn: 'root' })
export class NumberValueImperialUnitsStrategy implements FeatureValueStrategy {
  constructor(private unitsAdapter: UnitsAdapter) {}
  supports(
    feature: Feature<TypedFeatureProperties<number>, unknown>,
    propertyName: string
  ): boolean {
    const property = feature?.properties?.[propertyName];
    const supportedUnits = [
      Unit.Celsius,
      Unit.Liter,
      Unit.LiterHour,
      Unit.LiterMinute,
      Unit.CubicMeter,
      Unit.CubicMeterPerHour,
      Unit.Bar,
    ];
    const supportsUnit = supportedUnits.includes(property?.unit);

    return property?.type === DcTypes.number && supportsUnit;
  }

  transformValue(
    feature: Feature<TypedFeatureProperties<number>, unknown>,
    propertyName: string,
    digitsInfo?: string
  ): string {
    const property = feature?.properties?.[propertyName];
    const unit = property?.unit;

    return `${this.unitsAdapter.getDisplayValue(property?.value, unit, { digitsInfo })}`;
  }
}
